var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fi_12566137",
    enableBackground: "new 0 0 170 170",
    width: 170,
    height: 20,
    viewBox: "0 0 170 170",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m90 109.614c4.594-1.172 12.218-3.674 19.565-8.597 10.759-7.21 22.873-20.99 19.571-45.722-.166-2.366-1.877-23.155-12.124-47.252l-1.294-3.043h-61.436l-1.294 3.043c-10.247 24.098-11.959 44.887-12.124 47.252-3.302 24.732 8.812 38.512 19.571 45.722 7.347 4.923 14.972 7.425 19.565 8.597v41.716l-32.762 3.701.561 9.969h74.345l.561-9.968-32.705-3.695zm-23.999-16.904c-12.247-8.207-17.362-20.399-15.206-36.24l.036-.363c.013-.195 1.292-19.001 10.106-41.107h48.127c8.813 22.106 10.092 40.912 10.104 41.103l.037.368c4.794 35.218-28.55 42.976-34.195 44.03-2.485-.478-10.988-2.416-19.009-7.791z",
    fill: "#8BA4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m114.25 57.15-.05-.37-.02-.37c0-.05-.11-1.64-.48-4.41h-57.4c-.37 2.77-.48 4.37-.48 4.43l-.02.35-.05.37c-1.88 13.78 2.24 23.95 12.57 31.09 3.27 2.26 6.71 3.89 9.7 5.03 4.48 1.71 9.46 1.71 13.95 0 2.99-1.14 6.43-2.76 9.71-5.03 10.33-7.14 14.45-17.31 12.57-31.09z",
    fill: "#8BA4BF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWine);
export default __webpack_public_path__ + "static/media/Wine.42f176c5bf88c5e9eae7c580963c8589.svg";
export { ForwardRef as ReactComponent };